import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../features/auth/AuthProvider';
import { Icon } from '../components/Icon';
import { Avatar, ProfileSheet } from './ProfileSheet';

/** Avatar amb la pastilla del perfil actiu (§10.4): sempre se sap amb quin perfil s'actua. */
export function AvatarButton({ floating }: { floating?: boolean }) {
  const { t } = useTranslation('shell');
  const state = useAuth();
  const [open, setOpen] = useState(false);
  const signedIn = state.status === 'signedIn';
  const role = signedIn ? state.activeRole : null;

  return (
    <>
      <button
        type="button"
        className={`avatar-button${floating ? ' glass floating' : ''}`}
        aria-haspopup="dialog"
        aria-label={signedIn ? t('sheet.openFor', { role: t(`roles.${role ?? 'client'}`) }) : t('sheet.openGuest')}
        onClick={() => setOpen(true)}
      >
        {signedIn && role && <span className={`role-pill role-${role}`}>{t(`roles.${role}`)}</span>}
        {signedIn ? <Avatar name={state.user.displayName ?? state.user.email ?? ''} small /> : <Icon name="user" size={22} />}
      </button>
      <ProfileSheet open={open} onClose={() => setOpen(false)} />
    </>
  );
}
